//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  table: {
    minWidth: 750,
  },
  rowCell: {
    fontSize: 15,
    fontFamily: "segoe-ui",
    padding: "5px",
    border: "1px solid grey",
  },
  tableContainer: {},
  tableHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: 16,
    fontFamily: "segoe-ui !important",
    padding: 5,
    border: "1px solid",
  },

  contentGrid: {
    textAlign: "center",
  },
  categoryName:{
    fontSize: 18,
    fontWeight:"bold"
  },
  content1: {
    fontSize: 18,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 50,
  },
  pagination: {
    padding: 0,
    marginTop: 30,
    float: "right",
  },
  backBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 70,
    height: 35,
    textTransform: "capitalize",
    cursor: 'pointer',
    "&:hover":{
      backgroundColor: "#305698",
    }
  },
  exportBtn:{
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 70,
    textTransform: "capitalize",
    cursor: 'pointer',
    "&:hover":{
      backgroundColor: "#305698",
    },
    margin:"5px"
  }
}));
